import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Icon } from 'antd';
import './index.less';
const defaultOptions = {
  title: 'modal',
  show: false,
  okTxt: 'Ok',
  isOkBtn: true,
  cancelTxt: 'Cancel',
  isCancelBtn: true,
  width: '500',
  ok: () => {
    console.log('ok');
  },
  cancel: () => {
    console.log('cancel');
  },
  content: 'some text'
};
export class TantuterModal extends Component {
  constructor() {
    super();

    this.state = {
      ...defaultOptions
    };
  }
  open(options) {
    defaultOptions.show = true;
    this.setState({
      ...defaultOptions,
      ...options
    });
  }
  ok() {
    this.state.ok();
  }
  cancel() {
    this.state.cancel();
  }
  close() {
    this.setState({
      show: false
    });
  }
  render() {
    return (
      <div>
        {this.state.show ? (
          <div className="tantuer tantuer-modal">
            <div className="bg" onClick={this.close.bind(this)} />
            <div className="inner" style={{ width: this.state.width }}>
              <div className="modal-hd">
                <h3>{this.state.title}</h3>
                <Icon type="close" onClick={this.close.bind(this)} />
              </div>
              <div className="modal-con">{this.state.content}</div>
              {this.state.isOkBtn || this.state.isCancelBtn ? (
                <div className="modal-ft">
                  {this.state.isOkBtn && (
                    <Button
                      type="primary"
                      className="modal-ok"
                      onClick={this.ok.bind(this)}
                    >
                      {this.state.okTxt}
                    </Button>
                  )}
                  {this.state.isCancelBtn && (
                    <Button
                      className="modal-cancel"
                      onClick={this.cancel.bind(this)}
                    >
                      {this.state.cancelTxt}
                    </Button>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

let div = document.createElement('div');
document.body.appendChild(div);
let Modal = ReactDOM.render(React.createElement(TantuterModal), div);
export default Modal;
